module.exports = __webpack_public_path__ + "static/media/ico-alert-modal.d727e8c7.svg";